import { Injectable, inject } from '@angular/core';
import { StorageCurrentContextService } from './storage-current-context.service';

@Injectable()
export class CurrentSiteIdStore {
  private readonly storageCurrentContextService = inject(StorageCurrentContextService);

  get(): number | undefined {
    const id = this.storageCurrentContextService.get()?.currentSiteId;
    if (id === undefined || id === null) return undefined;
    return isNaN(id) || id <= 0 ? undefined : id;
  }

  set(id: number): void {
    this.storageCurrentContextService.createOrUpdate({ currentSiteId: id });
  }

  clear(): void {
    this.storageCurrentContextService.createOrUpdate({ currentSiteId: undefined });
  }
}
